import { ScheduleWbsTemplateBase } from './base/schedule-wbs-template-base';

export class ScheduleWbsTemplate extends ScheduleWbsTemplateBase { }